<div class="modal-backdrop" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    
    <div class="modal-header">
      <h2 style="margin: 0; color: #f8fafc; font-size: 1.25rem;">Copy from Global Frame Groups</h2>
      <button class="close-btn" (click)="onClose()" *ngIf="!isCopying">&times;</button>
    </div>

    <div class="modal-body">
      <p style="color: #cbd5e1; margin-bottom: 16px; font-size: 0.95rem;">
        Select a global frame group to completely clone into this machine's local configuration.
      </p>

      <div *ngIf="isLoading" style="font-size: 0.95rem; color: #94a3b8; margin: 20px 0; display: flex; align-items: center;">
         <span class="spinner-inline" style="border-color: #3b82f6; border-bottom-color: transparent;"></span> Loading global frame groups...
      </div>

      <div class="custom-tree-select" *ngIf="!isLoading" style="max-height: 350px; overflow-y: auto; border: 1px solid #334155; border-radius: 4px; background: #0f172a; padding: 8px;">
         <div *ngIf="globalFrameGroupsGrouped.length === 0" style="color: #64748b; font-size: 0.85rem; padding: 4px;">
            No global frame groups found.
         </div>
         <div *ngFor="let group of globalFrameGroupsGrouped">
            <div (click)="group.expanded = !group.expanded" style="cursor: pointer; padding: 6px; display: flex; align-items: center; background: #1e293b; margin-bottom: 4px; border-radius: 4px; user-select: none;">
               <span style="margin-right: 8px; font-size: 0.75rem; color: #94a3b8;">{{ group.expanded ? '▼' : '▶' }}</span>
               <strong style="color: #cbd5e1; font-size: 0.9rem;">Theme: {{ group.themeId }}</strong>
            </div>
            <div *ngIf="group.expanded" style="padding-left: 20px; margin-bottom: 8px;">
               <div *ngFor="let opt of group.frames" 
                    (click)="selectFrameGroup(opt)"
                    [style.background]="(selectedGroup?.themeId === opt.themeId && selectedGroup?.frameId === opt.frameId) ? 'rgba(59,130,246,0.3)' : 'transparent'"
                    style="cursor: pointer; padding: 6px; border-radius: 4px; display: flex; align-items: center; gap: 8px; margin-bottom: 2px; transition: background 0.2s;">
                  <input type="radio" [checked]="selectedGroup?.themeId === opt.themeId && selectedGroup?.frameId === opt.frameId" style="margin: 0; cursor: pointer; width: 14px; height: 14px; accent-color: #3b82f6;">
                  <span style="font-size: 0.85rem; color: #f8fafc;">{{ opt.displayName }}</span>
               </div>
               <div *ngIf="group.frames.length === 0" style="padding: 4px; color: #64748b; font-size: 0.85rem; font-style: italic;">No frame groups in this theme</div>
            </div>
         </div>
      </div>
      
      <div *ngIf="isCopying" style="margin-top: 16px; padding: 12px; background: rgba(59, 130, 246, 0.1); border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 6px; display: flex; align-items: center; color: #60a5fa;">
         <span class="spinner-inline" style="border-color: #3b82f6; border-bottom-color: transparent; margin-right: 12px;"></span>
         <span>Copying files and database records to machine... This may take a moment.</span>
      </div>
    </div>

    <div class="modal-footer" style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 12px;">
      <button class="secondary-btn" (click)="onClose()" [disabled]="isCopying">Cancel</button>
      <button class="primary-btn" (click)="onCopy()" [disabled]="!selectedGroup || isCopying">
         Copy to Machine
      </button>
    </div>
  </div>
</div>
